"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.execNode = void 0;
var isEmpty = function (value) { return value === null || value === undefined; };
var convertConditionsToTree = function (conditionsNode) {
    // Start with the first condition as the current node
    var current = conditionsNode.conditions[0];
    // Iterate over the conditions, starting from the second condition
    for (var i = 1; i < conditionsNode.conditions.length; i++) {
        var condition = conditionsNode.conditions[i];
        if (condition.type === 'conditionJoin') {
            // Create a new node with the joiner as the type
            // and the current node and the next condition as children
            current = {
                type: condition.joiner,
                left: current,
                right: condition.expression,
            };
        }
    }
    // Return the constructed tree
    return current;
};
var toDate = function (value) {
    var formats = [
        /^\d\d\d\d[/-]\d\d?[/-]\d\d?$/, // YYYY-MM?-DD?
        /^\d\d?[/-]\d\d?[/-]\d\d\d?\d?/, // DD?-MM?-YYY?Y?
        /^\d\d?[/-][a-zA-Z]{3}[/-]\d\d\d?\d?$/, // DD-Mon-YYYY
    ];
    if (typeof (value) === 'string' && formats.some(function (f) { return f.test(value); })) {
        value = new Date(value);
    }
    if (value instanceof Date) {
        var dt = value.toISOString();
        return dt.split('T')[0];
    }
    return null;
};
var toNumber = function (value, aggro) {
    if (typeof (value) === 'string') {
        if (value.match(/[^a-zA-Z0-9\.]/)) {
            return null;
        }
    }
    var num = parseFloat(value);
    return isNaN(num) ? null : num;
};
var toString = function (value, op) {
    if (isEmpty(value)) {
        return value;
    }
    value = "".concat(value);
    if (op === '=' || op === '<>') {
        value = value.toLowerCase();
    }
    return value;
};
var normalize = function (left, right) {
    var lt = typeof (left);
    var rt = typeof (right);
    if (lt !== rt) {
        if (lt === 'number') {
            return [left, parseFloat(right)];
        }
        if (rt === 'number') {
            return [parseFloat(left), right];
        }
    }
    else {
        if (lt === null || lt === 'undefined' && rt === null || rt === 'undefined') {
            return [null, null];
        }
    }
    return [left, right];
};
var execNode = function (scope, ast, elmt) {
    switch (ast.type) {
        case 'null':
            return null;
        case 'boolean':
            return ast.value;
        case 'number':
            return ast.value;
        case 'string':
            return ast.value;
        case 'regex':
            return ast.value;
        case 'identifier':
            return execIdentifier(scope, ast, elmt);
        case 'conditions':
            return execConditions(scope, ast, elmt);
        case 'and':
            return execAnd(scope, ast, elmt);
        case 'or':
            return execOr(scope, ast, elmt);
        case 'condition':
            return execCondition(scope, ast, elmt);
        case 'function':
            return execFunction(scope, ast, elmt);
        default:
            throw new Error("Unknown AST node type: \"".concat(ast.type, "\""));
    }
};
exports.execNode = execNode;
var execIdentifier = function (scope, ast, elmt) {
    if (ast.value.startsWith('$')) {
        return scope.getSymbol(ast.value.slice(1));
    }
    if (!elmt || typeof (elmt) !== 'object')
        throw new Error('Element is not an object');
    return elmt[ast.value];
};
var execConditions = function (scope, ast, elmt) {
    var newAst = convertConditionsToTree(ast);
    var result = (0, exports.execNode)(scope, newAst, elmt);
    if (ast.negate) {
        return !result;
    }
    return result;
};
var execNumericalCondition = function (scope, ast, elmt) {
    var _a, _b, _c, _d, _e, _f;
    var left = (0, exports.execNode)(scope, ast.left, elmt);
    var right = (0, exports.execNode)(scope, ast.right, elmt);
    var _g = __read(normalize((_c = (_b = (_a = toDate(left)) !== null && _a !== void 0 ? _a : toNumber(left)) !== null && _b !== void 0 ? _b : toString(left, ast.op)) !== null && _c !== void 0 ? _c : undefined, (_f = (_e = (_d = toDate(right)) !== null && _d !== void 0 ? _d : toNumber(right)) !== null && _e !== void 0 ? _e : toString(right, ast.op)) !== null && _f !== void 0 ? _f : undefined), 2), normLeft = _g[0], normRight = _g[1];
    switch (ast.op) {
        case '=':
            return normLeft === normRight;
        case '<>':
            return normLeft !== normRight;
        case '>':
            return normLeft > normRight;
        case '<':
            return normLeft < normRight;
        case '>=':
            return normLeft >= normRight;
        case '<=':
            return normLeft <= normRight;
    }
    throw new Error("Unknown numerical operator ".concat(ast.op));
};
var execCondition = function (scope, ast, elmt) {
    var left = (0, exports.execNode)(scope, ast.left, elmt);
    // If we have an in operator, the right side is an array
    var right = Array.isArray(ast.right) ?
        ast.right.map(function (arg) { return (0, exports.execNode)(scope, arg, elmt); }) :
        (0, exports.execNode)(scope, ast.right, elmt);
    switch (ast.op) {
        case '=':
        case '<>':
        case '>':
        case '<':
        case '>=':
        case '<=':
            return execNumericalCondition(scope, ast, elmt);
        case 'matches':
            return new RegExp(right).test(left);
        case 'like':
            return new RegExp(right.replace(/%/g, '.*').replace(/_/g, '.')).test(left);
        case 'in':
            return right.includes(left);
        default:
            throw new Error("Unknown operator ".concat(ast.op));
    }
};
var execAnd = function (scope, ast, elmt) {
    var left = (0, exports.execNode)(scope, ast.left, elmt);
    var right = (0, exports.execNode)(scope, ast.right, elmt);
    return !!left && !!right;
};
var execOr = function (scope, ast, elmt) {
    var left = (0, exports.execNode)(scope, ast.left, elmt);
    var right = (0, exports.execNode)(scope, ast.right, elmt);
    return !!left || !!right;
};
var execFunction = function (scope, ast, elmt) {
    var name = ast.name.value.toLowerCase().trim();
    // If there is only one argument, wrap it in an array
    if (!Array.isArray(ast.arguments)) {
        ast.arguments = [ast.arguments];
    }
    var args = ast.arguments.map(function (arg) { return (0, exports.execNode)(scope, arg, elmt); });
    var func = scope.getFunction(name);
    if (!!func) {
        var result = func.apply(null, __spreadArray(__spreadArray([], __read(args), false), [elmt], false));
        // console.log(name, ...args, 'returned', result)
        return result;
    }
    else {
        throw new Error("Unknown function ".concat(name));
    }
};
